import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";

function Markets() {
  // const [user, setUsers] = useState(null);
  const [userr, setUserss] = useState(null);
  const [useadvertisement, setadvertisement] = useState(null);
  const [loading, setLoading] = useState(true); // Track loading state

  const [useallMarketData, setuseallMarketData] = useState(null);
  const marketchart_id = localStorage.getItem("marketchart_id");
  console.warn(marketchart_id);
  // console.warn("rrr",marketchart_id)
  const yearrr = localStorage.getItem("yearrr");
  const navigate = useNavigate();

  const [time, setTime] = useState(null);

  const [usesetmarket, setmarket] = useState(null);

  const [useresults, setresults] = useState(null);
  const [useresult, setresult] = useState(null);
  console.warn("ruyrfuyf", useresult);

  const record = async () => {
    try {
      setLoading(true);
      // const response = await fetch(`${process.env.REACT_APP_API_URL}public/api/satta-record-chart/${marketchart_id}/2023`, { method: 'GET' });
  const response = await fetch(
  `${process.env.REACT_APP_API_URL}/Admin/public/api/satta-record-chart/${marketchart_id}/${yearrr || currentYear}`,
  {
    method: "GET",
  }
);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.warn(data); // Log the response data
      setresults(data);
      setresult(data.market_name[0]);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    record();
  }, []);

  const [usemarketname, setusemarketname] = useState("");
  const [useyearr, setyearr] = useState("");
  const [titlee, settitlee] = useState("");

  const handleClick1 = async (market_id) => {
    navigate("/Result");
    localStorage.setItem("marketchart_id", market_id);
    window.location.reload();
  };

  const [usemarketnamee, setusemarketnamee] = useState("");
  const [useyear, setyear] = useState("");
  const [title, settitle] = useState("");
  //  console.log(usetitleyear)

  const handleClick2 = async (market_id) => {
    navigate("/Market");
    localStorage.setItem("marketchart_id", market_id);
    window.location.reload();
  };
  const currentYear = new Date().getFullYear();

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {useresults ? (
            <div className="">
              <div class="octoberresultchart">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <h1 className="text-white">
                        {useresults &&
                          useresults.data &&
                          Object.keys(useresults.data).map((month, index) => (
                            <div key={month}>
                              {useresults.data[month].map(
                                (result, resultIndex) => (
                                  <span>
                                    {" "}
                                    {index === 0 &&
                                      resultIndex === 0 &&
                                      result.market_name}
                                  </span>
                                ),
                              )}
                            </div>
                          ))}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <div className="allmarket table-responsive">
            <table className="table table-borderd">
              <tbody>
                <tr>
                  {useresults ? (
                    <>
                      <th className="forfirtcolor">{yearrr || currentYear}</th>
                    </>
                  ) : null}
                  {useresults ? (
                    <>
                      <th className="forfirtcolor">January</th>
                      <th className="forfirtcolor">February</th>
                      <th className="forfirtcolor">March</th>
                      <th className="forfirtcolor">April</th>
                      <th className="forfirtcolor">May</th>
                      <th className="forfirtcolor">June</th>
                      <th className="forfirtcolor">July</th>
                      <th className="forfirtcolor">August</th>
                      <th className="forfirtcolor">September</th>
                      <th className="forfirtcolor">October</th>
                      <th className="forfirtcolor">November</th>
                      <th className="forfirtcolor">December</th>
                    </>
                  ) : null}
                </tr>

                {useresults &&
                  useresults.data &&
                  Array.from({ length: 30 }, (_, i) => i + 1).map((date) => (
                    <tr key={date} style={{ color: "white" }}>
                      <td className="forfirtcolor">{date}</td>
                      {Object.entries(useresults.data).map(
                        ([month, records]) => (
                          <td key={month}>
                            {records[date - 1] ? records[date - 1].result : ""}
                          </td>
                        ),
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}

export default Markets;
